import { sortBy } from "./arrays";

export const jsonStringifySort = (value: any): string => {
  return JSON.stringify(jsonSort(value));
};

export const jsonSort = (value: any): any => {
  if (Array.isArray(value)) {
    return value.map((subValue) => jsonStringifySort(subValue));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      sortBy(Object.entries(value), ([key]) => key).map(([key, value]) => [
        key,
        jsonSort(value),
      ])
    );
  }
  return value;
};
